import { NavLink, useLocation } from "react-router-dom";

import { useAuth } from "../../js/hooks/useAuth";

import { useNotifications } from "../../js/hooks/useNotifications";

import { useHubUnread } from "../../js/hooks/useHubUnread";

import NavUnread from "../messaging/NavUnread";

import { toTitleCase } from "../../js/utils/titleCase";

import { manualsUrl, JOURNEY_LINK_PROPS } from "../../js/utils/siteLinks";

import { brokerNavLinks } from "../../js/navigation/deskNav";

import { tourNavId } from "@tour/film.js";



export default function BrokerNav() {

  const { session } = useAuth();

  const { pathname } = useLocation();

  const links = brokerNavLinks(session);

  const { clientUnread, officeUnread } = useNotifications();

  const hubUnread = useHubUnread();



  return (

    <nav className="desk-subnav" aria-label="Broker" data-tour="desk-subnav">

      <ol className="desk-subnav-list">

        {links.map((link) => (

          <li key={link.to}>

            <NavLink

              to={link.to}

              end={link.end}

              data-tour={tourNavId(link.label)}

              className={({ isActive }) => {

                const onHub = link.to.startsWith("/broker/hub") && pathname.startsWith("/broker/hub");

                return `desk-subnav-link${isActive || onHub ? " is-active" : ""}`;

              }}

            >

              {toTitleCase(link.label)}

              {link.unread === "office" ? (

                <NavUnread count={officeUnread} />

              ) : link.unread === "client" ? (

                <NavUnread count={clientUnread} />

              ) : link.unread === "hub" ? (

                <NavUnread count={hubUnread} />

              ) : null}

            </NavLink>

          </li>

        ))}

        <li>

          <a

            href={manualsUrl("broker", session)}

            className="desk-subnav-link"

            data-tour={tourNavId("User Guide")}

            {...JOURNEY_LINK_PROPS}

          >

            {toTitleCase("User Guide")}

          </a>

        </li>

      </ol>

    </nav>

  );

}


